import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronRight, X } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

/**
 * Cross-board move menu. Fetches /my/accessible-lists.
 */
export default function MoveCardMenu({ currentListId, onMove, onClose }) {
  const [accessibles, setAccessibles] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/my/accessible-lists");
        setAccessibles(r.data);
        // expand the current board by default
        const cur = r.data.find((b) => b.lists.some((l) => l.list_id === currentListId));
        if (cur) setExpanded({ [cur.board_id]: true });
      } catch { toast.error("Gagal memuat papan"); }
      finally { setLoading(false); }
    })();
  }, [currentListId]);

  return (
    <div className="absolute left-1 right-1 top-12 md:left-auto md:right-0 md:w-72 bg-white border-2 border-black shadow-brut z-30 animate-slideUp max-h-[min(24rem,70vh)] overflow-hidden flex flex-col" data-testid="move-menu">
      <div className="border-b border-black p-2 font-mono text-[10px] uppercase tracking-widest bg-[#F0F0F0] flex items-center justify-between gap-2">
        <span className="min-w-0 truncate">PINDAH KARTU</span>
        <button onClick={onClose} className="w-8 h-8 md:w-6 md:h-6 shrink-0 hover:bg-black hover:text-white touch-manipulation"><X size={12} className="mx-auto" strokeWidth={2.5} /></button>
      </div>
      <div className="overflow-y-auto flex-1">
        {loading && <div className="p-4 font-mono text-xs text-black/50 animate-pulse">Memuat…</div>}
        {!loading && accessibles.length === 0 && (
          <div className="p-4 font-mono text-xs text-black/50">Tidak ada papan lain yang bisa diakses.</div>
        )}
        {accessibles.map((b) => {
          const open = expanded[b.board_id];
          return (
            <div key={b.board_id} className="border-b border-black/10">
              <button onClick={() => setExpanded({ ...expanded, [b.board_id]: !open })}
                data-testid={`expand-board-${b.board_id}`}
                className="w-full text-left px-3 py-2 font-mono text-[11px] uppercase tracking-widest font-bold bg-canary/40 hover:bg-canary flex items-center gap-2 btn-brut min-w-0">
                {open ? <ChevronDown size={12} strokeWidth={3} /> : <ChevronRight size={12} strokeWidth={3} />}
                <span className="truncate flex-1">{b.board_title}</span>
                <span className="bg-black text-white px-1.5 py-0.5 text-[9px]">{b.lists.length}</span>
              </button>
              {open && (
                <div className="bg-white">
                  {b.lists.map((l) => (
                    <button key={l.list_id} onClick={() => onMove(l.list_id)} disabled={l.list_id === currentListId}
                      data-testid={`move-to-list-${l.list_id}`}
                      className="w-full text-left pl-8 pr-3 py-2 font-mono text-xs uppercase tracking-wider border-t border-black/10 hover:bg-klein hover:text-white btn-brut disabled:opacity-30 disabled:cursor-not-allowed truncate touch-manipulation">
                      {l.list_id === currentListId ? "✓ " : "→ "}{l.title}
                    </button>
                  ))}
                  {b.lists.length === 0 && (
                    <div className="pl-8 pr-3 py-2 font-mono text-[10px] text-black/40 italic">(tidak ada daftar)</div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
